// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 854 ? "pdfjs" : chunkId) + "." + {"854":"0ea1b3a1","967":"5aaaad8b"}[chunkId] + ".chunk.js";
};